module.exports = __webpack_public_path__ + "static/media/jo.17530dec.svg";